export const Api_VariavelGlobal = 'https://gestor.bebilogo.com.br';
export const Cliente = 'Bebilogo Conveniência';
export const Tipo_Cliente = '(Pedidos, Pdv, Estoque, Financeiro)';
export const Title_1 = 'Bebilogo';
export const Title_2 = 'Conveniência';